import { Outlet } from "react-router-dom";
import { AppRouteProps } from "src/components/router/AppRoute";
import CreateTab from "src/hooks/useTab";
import { wrapRoutes } from "src/components/router/AuthWrapper";
import AdminTools from ".";

export const adminToolsRoutes: AppRouteProps[] = [
  {
    path: "admin",
    element: (
      <PatientLayout>
        <Outlet />
      </PatientLayout>
    ),
    children: wrapRoutes([
      { path: "tools",element: <PageWrapper title="Admin Araçları" />, role: "frmAdminTools" },

    ]),
  },
];

function PatientLayout(props: any) {
  return <>{props.children}</>;
}

function PageWrapper({ title }: { title: string }) {
  return <CreateTab title={title} element={<AdminTools />} />;
}
